import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import PageNotFound from "./components/PageNotFound";
import { AuthConditionedRoute } from "./utils/Auth";
import { SnackbarProvider, wrapComponent } from "react-snackbar-alert";

// Components
import Board from "./components/Board";
import Login from "./components/Login";
import Signup from "./components/Signup";
import AdminBoard from "./components/AdminBoard";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";

function App() {
    const RouteredApp = wrapComponent(function({ createSnackbar }) {
        return (
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Redirect exact from="/" to="/login" />
                    <AuthConditionedRoute
                        alert={createSnackbar}
                        path="/board"
                        shouldBeLogged={true}
                        pathIfFailedCondition="/login"
                        component={Board}
                    />
                    <AuthConditionedRoute
                        alert={createSnackbar}
                        path="/adminBoard"
                        shouldBeLogged={true}
                        pathIfFailedCondition="/login"
                        component={AdminBoard}
                    />
                    <AuthConditionedRoute
                        alert={createSnackbar}
                        path="/login"
                        shouldBeLogged={false}
                        pathIfFailedCondition="/board"
                        component={Login}
                    />
                    <AuthConditionedRoute
                        alert={createSnackbar}
                        shouldBeLogged={false}
                        path="/signup"
                        pathIfFailedCondition="/board"
                        component={Signup}
                    />
                    <AuthConditionedRoute
                        alert={createSnackbar}
                        path="/forgotPassword"
                        shouldBeLogged={false}
                        pathIfFailedCondition="/board"
                        component={ForgotPassword}
                    />
                    <AuthConditionedRoute
                        alert={createSnackbar}
                        path="/resetPassword"
                        shouldBeLogged={false}
                        pathIfFailedCondition="/board"
                        component={ResetPassword}
                    />
                    <Route
                        alert={createSnackbar}
                        path="/privacyPolicy"
                        shouldBeLogged={false}
                        pathIfFailedCondition="/login"
                        component={PrivacyPolicy}
                    />
                    <Route component={PageNotFound} />
                </Switch>
            </BrowserRouter>
        );
    });

    return (
        <SnackbarProvider position="top">
            <RouteredApp />
        </SnackbarProvider>
    );
}

export default App;
